/***************************************************************************************/ 
 /* This file is generated. Do not edit by hand unless you 100% know what you're doing.. */ 
 /***************************************************************************************/ 
 
 export enum UserPropKey {  
    AddressLine1 = "AddressLine1",
    AddressLine2 = "AddressLine2",
    City = "City",
    CountryCode = "CountryCode",
    DefaultGroupId = "DefaultGroupId",
    Email = "Email",
    Emails = "Emails",
    FirstName = "FirstName",
    Id = "Id",
    IsArchived = "IsArchived",
    Language = "Language",
    LastInteraction = "LastInteraction",
    LastName = "LastName",
    LeaseId = "LeaseId",
    LeaseIds = "LeaseIds",
    LimitToGroupId = "LimitToGroupId",
    LocationId = "LocationId",
    LocationIds = "LocationIds",
    Name = "Name",
    Number = "Number",
    PhoneNumber = "PhoneNumber",
    PhoneNumbers = "PhoneNumbers",
    PostalCode = "PostalCode",
    SMSOptOut = "SMSOptOut",
    State = "State",
    TenantId = "TenantId",
    TenantIds = "TenantIds",
    UnitId = "UnitId",
    UnitIds = "UnitIds",

}